import { useReducer } from "react"
import useFetch from "../../../hook/useFetch"
import parse from 'html-react-parser';
import { useDispatch, useSelector } from "react-redux";
import { notificationActions } from "../../../store/notification-slice";
import { useNavigate } from "react-router-dom";
import useRole from '../../../hook/useRole'
export default function NewProductType({ producttype }) {

    const reducer = (state, action) => {
        switch (action.type) {
            case 'title':
                return { ...state, title: action.data }

            case 'description':
                return { ...state, description: action.data }
        }
    }


    const [componentState, componentDispatch] = useReducer(reducer, {
        title: producttype ? producttype.title : null,
        description: producttype ? producttype.description : null
    })

    const { error, update, post } = useFetch()

    let token = useSelector(state => state.user.token)

    let dispatch = useDispatch()

    let navigate = useNavigate()

    const{hasrole}=useRole('rsosuperuser')


    return <div className="edit-container grid-container-2-col" >

        <form className="edit-form bg-white left-col" onSubmit={(e) => {
            e.preventDefault()

            if (producttype) {

                update(`/admin/producttype?token=${token}&id=${producttype.id}`, componentState, (data) => {
                    dispatch(notificationActions.setNotification({
                        status: false,
                        message: data
                    }
                    ))
                }, (data) => {

                    dispatch(notificationActions.setNotification({
                        status: true,
                        message: data
                    }
                    ))

                    navigate('/admin/producttypes', {
                        state: {
                            refetch: true
                        }
                    })
                })

                return
            }

            post(`/admin/producttype?token=${token}`, componentState, (data) => {
                dispatch(notificationActions.setNotification({
                    status: false,
                    message: data
                }
                ))
            }, (data) => {
              
                dispatch(notificationActions.setNotification({
                    status: true,
                    message: data
                }
                ))

                navigate('/admin/producttypes', {
                    state: {
                        refetch: true
                    }
                })
            })
        }} >

            {error &&
                <div className="alert bg-danger " >
                    <p>{parse(error)}</p>
                </div>
            }

            <div className="form-group">
                <label>Title</label>
                <input type="text" className="form-control" placeholder="title" defaultValue={componentState.title} onInput={(e) => {
                    componentDispatch(
                        {
                            type: 'title',
                            data: e.target.value
                        }
                    )
                }} required />

            </div>

            <div className="form-group">
                <label >Description</label>
                <textarea className="form-control" placeholder="description" defaultValue={componentState.description} onInput={(e) => {
                    componentDispatch(
                        {
                            type: 'description',
                            data: e.target.value
                        }
                    )
                }} />


            </div>
            <button disabled={producttype.id===1 && !hasrole} type="submit" className="btn btn-primary" >{producttype ? 'UPDATE' : 'REGISTER'}</button>


        </form>

    </div>

}
